import React, { Component } from 'react';
import axios from 'axios';
import ScrollupSection from '../components/scrollupSection/scrollUp';
import Header from '../components/welcomeSection/header';
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom';

class Checkout extends Component {
    state = {
        formData: {
            dni: '',
            name: '',
            lastName: '',
            email: '',
            confirmEmail: '',
            phone: '',
            province: '',
            city: '',
            address: '',
        },
        paymentMethod: 'TRANSFER',
        price: 0,
        title: '',
        quantity: 0,
        errors: {},
    }

    componentDidMount() {
        const params = new URLSearchParams(this.props.location.search)
        const quantity = params.get('quantity');
        const game = params.get('game');

        const { location } = this.props;
        const { price, title } = location.state || {};

        if (!quantity || !game || !price || !title) {
            this.goToIndex();
        }

        this.setState({
            formData: {
                ...this.state.formData,
            },
            price: price,
            title: title,
            quantity: quantity,
        })

        const eventId = uuidv4();
        const eventName = 'InitiateCheckout';
        if (window.fbq) {
            window.fbq('track', eventName, {}, { eventID: eventId });
        }

        axios.post('https://api.proyectoshark.com/games/public/tracking/event', {
            eventName,
            eventId
        })
            .then(res => {
                console.log(`Event ${eventName} sent successfully:`, res.data);
            })
            .catch(err => {
                console.log(err)
            })
    }

    handleChange = (e) => {
        const { name, value } = e.target
        this.setState((prevState) => ({
            formData: {
                ...prevState.formData,
                [name]: value,
            },
            errors: {
                ...prevState.errors,
                [name]: '',
            }
        }))
    }

    validate = () => {
        const { formData } = this.state
        const errors = {}
        if (!formData.name) errors.name = 'Nombres es obligatorio'
        if (!formData.lastName) errors.lastName = 'Apellidos es obligatorio'
        if (!formData.email) errors.email = 'Email es obligatorio'
        if (!formData.confirmEmail) errors.confirmEmail = 'Confirmar Email es obligatorio'
        if (formData.confirmEmail !== formData.email) errors.confirmEmail = 'Los correos no coinciden'
        if (!formData.phone) errors.phone = 'Celular es obligatorio'
        if (!formData.province) errors.province = 'Provincia es obligatoria'
        if (!formData.city) errors.city = 'Ciudad es obligatoria'
        if (!formData.address) errors.address = 'Dirección es obligatoria'
        if (!formData.dni) errors.dni = 'Cédula es obligatorio'
        return errors
    }

    handleSubmit = () => {
        const errors = this.validate()
        if (Object.keys(errors).length > 0) {
            this.setState({ errors })
            return
        }

        const params = new URLSearchParams(window.location.search);
        const quantity = params.get('quantity');
        const game = params.get('game');

        if (!quantity || !game) {
            this.goToIndex();
        }

        if (this.state.paymentMethod === 'CC') {
            return;
        }

        const clientTransactionId = uuidv4();

        axios.post('https://api.proyectoshark.com/games/public/purchase', {
            client_transaction_id: clientTransactionId,
            game_id: game,
            quantity: quantity,
            payment_method: this.state.paymentMethod,
            name: this.state.formData.name,
            last_name: this.state.formData.lastName,
            email: this.state.formData.email,
            dni: this.state.formData.dni,
            phone: this.state.formData.phone,
            city: this.state.formData.city,
            province: this.state.formData.province,
            address: this.state.formData.address,
        })
            .then(res => {
                if (this.state.paymentMethod === 'TRANSFER') {
                    this.props.history.push({
                        pathname: '/checkout/transfer',
                        search: `?trx=${clientTransactionId}`,
                        state: {
                            client_transaction_id: clientTransactionId,
                            title: this.state.title,
                        },
                    })
                } else if (this.state.paymentMethod === 'CC') {
                    this.callToPayPhone(res.data, clientTransactionId)
                }
            })
            .catch(err => {
                console.log(err)
                this.goToIndex();
            })

        const eventId = uuidv4();
        const eventName = 'AddPaymentInfo';
        if (window.fbq) {
            window.fbq('track', eventName, {}, { eventID: eventId });
        }

        axios.post('https://api.proyectoshark.com/games/public/tracking/event', {
            eventName,
            eventId
        })
            .then(res => {
                console.log(`Event ${eventName} sent successfully:`, res.data);
            })
            .catch(err => {
                console.log(err)
            })
    }

    callToPayPhone = ({ quantity, price, total, title }, clientTransactionId) => {
        axios.post(`https://pay.payphonetodoesposible.com/api/button/Prepare`,
            {
                "amount": total * 100,
                "amountWithoutTax": total * 100,
                "clientTransactionId": clientTransactionId,
                "reference": title.slice(0, 95) + ' x ' + quantity,
                "storeId": "f73b490d-1629-4e3f-bb92-93fbc0954fe0",
                "currency": "USD",
                "responseUrl": "https://proyectoshark.com/checkout/confirmation",
                "cancellationUrl": "https://proyectoshark.com/checkout/cancellation",
                "timeZone": -5,
                "order": {
                    "billTo": {
                        "address1": this.state.formData.address,
                        "country": "EC",
                        "state": this.state.formData.province,
                        "locality": this.state.formData.city,
                        "firstName": this.state.formData.name,
                        "lastName": this.state.formData.lastName,
                        "email": this.state.formData.email,
                    },
                },
                "email": this.state.formData.email,
            },
            {
                headers: {
                    Authorization: `Bearer ${process.env.REACT_APP_PAYPHONE_TOKEN}`,
                    'Content-Type': 'application/json',
                }
            },
        )
            .then(res => {
                const redirectUrl = res.data.payWithCard
                window.location.href = redirectUrl
            })
            .catch(err => {
                console.log(err)
                this.goToIndex();
            })
    }

    goToIndex = () => {
        this.props.history.push('/')
    }

    render() {
        const { formData, errors, price, title, quantity } = this.state
        return (
            <div className="miami">
                <ScrollupSection />
                <div className="all-area">
                    <Header />
                    <section className="section about-app-area ptb_50">
                        <div className="container">
                            <div className="checkout-container">
                                <div className="form-section">
                                    <h2>Datos Personales</h2>

                                    <div className="form-group">
                                        <label>Cédula *</label>
                                        <input type="text" name="dni" value={formData.dni} onChange={this.handleChange} placeholder='Cédula' />
                                        {errors.dni && <small className="error">{errors.dni}</small>}
                                    </div>

                                    <div className="form-grid">
                                        <div className="form-group">
                                            <label>Nombre *</label>
                                            <input type="text" name="name" value={formData.name} onChange={this.handleChange} placeholder="Nombre" />
                                            {errors.name && <small className="error">{errors.name}</small>}
                                        </div>
                                        <div className="form-group">
                                            <label>Apellido *</label>
                                            <input type="text" name="lastName" value={formData.lastName} onChange={this.handleChange} placeholder="Apellido" />
                                            {errors.lastName && <small className="error">{errors.lastName}</small>}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>Email *</label>
                                        <input type="email" name="email" value={formData.email} onChange={this.handleChange} placeholder='Email' />
                                        {errors.email && <small className="error">{errors.email}</small>}
                                    </div>

                                    <div className="form-group">
                                        <label>Confirmar Email *</label>
                                        <input type="email" name="confirmEmail" value={formData.confirmEmail} onChange={this.handleChange} placeholder='Confirmar email' />
                                        {errors.confirmEmail && <small className="error">{errors.confirmEmail}</small>}
                                    </div>

                                    <div className="form-group">
                                        <label>Celular *</label>
                                        <input type="text" name="phone" value={formData.phone} onChange={this.handleChange} placeholder='Celular' />
                                        {errors.phone && <small className="error">{errors.phone}</small>}
                                    </div>

                                    <div className="form-grid">
                                        <div className="form-group">
                                            <label>País *</label>
                                            <input type="text" value="Ecuador" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label>Provincia *</label>
                                            <select name="province" value={formData.province} onChange={this.handleChange} placeholder="Provincia">
                                                <option value="">Selecciona una provincia</option>
                                                <option>Azuay</option>
                                                <option>Bolívar</option>
                                                <option>Cañar</option>
                                                <option>Carchi</option>
                                                <option>Chimborazo</option>
                                                <option>Cotopaxi</option>
                                                <option>El Oro</option>
                                                <option>Esmeraldas</option>
                                                <option>Galápagos</option>
                                                <option>Guayas</option>
                                                <option>Imbabura</option>
                                                <option>Loja</option>
                                                <option>Los Ríos</option>
                                                <option>Manabí</option>
                                                <option>Morona Santiago</option>
                                                <option>Napo</option>
                                                <option>Orellana</option>
                                                <option>Pastaza</option>
                                                <option>Pichincha</option>
                                                <option>Santa Elena</option>
                                                <option>Santo Domingo de los Tsáchilas</option>
                                                <option>Sucumbíos</option>
                                                <option>Tungurahua</option>
                                                <option>Zamora Chinchipe</option>
                                            </select>
                                            {errors.province && <small className="error">{errors.province}</small>}
                                        </div>
                                        <div className="form-group">
                                            <label>Ciudad *</label>
                                            <input type="text" name="city" value={formData.city} onChange={this.handleChange} placeholder='Ciudad' />
                                            {errors.city && <small className="error">{errors.city}</small>}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>Dirección *</label>
                                        <input type="text" name="address" value={formData.address} onChange={this.handleChange} placeholder='Dirección' />
                                        {errors.address && <small className="error">{errors.address}</small>}
                                    </div>

                                </div>

                                <div className="summary-section">
                                    <h2>Tu pedido</h2>
                                    <table className="order-summary">
                                        <thead>
                                            <tr>
                                                <th>Producto</th>
                                                <th>Subtotal</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{title} x {quantity}</td>
                                                <td>${price * quantity}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Total</strong></td>
                                                <td><strong>${price * quantity}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <h3>Selecciona tu método de pago</h3>

                                    <div className="payment-methods">
                                        <label className="payment-option">
                                            <input
                                                className="payment-radio"
                                                type="radio"
                                                name="payment"
                                                value="TRANSFER"
                                                checked={this.state.paymentMethod === 'TRANSFER'}
                                                onChange={(e) => this.setState({ paymentMethod: e.target.value })}
                                            />
                                            Transferencia bancaria o depósito
                                            <p className="note">
                                                Por favor, NO PROCEDAS SI NO ESTÁS SEGURO de que quieres realizar la compra. Realiza tu pago directamente con transferencia o depósito a nuestra cuenta bancaria. Usa el número del pedido como referencia de pago. Tu pedido no se procesará hasta que se haya recibido el importe en nuestra cuenta.
                                            </p>
                                        </label>

                                        <label className="payment-option">
                                            <input
                                                className="payment-radio"
                                                disabled={true}
                                                type="radio"
                                                name="payment"
                                                value="CC"
                                                checked={this.state.paymentMethod === 'CC'}
                                                onChange={(e) => this.setState({ paymentMethod: e.target.value })}
                                            />
                                            Tarjeta de crédito o débito
                                            <div className="logos">
                                                <img src="https://shark-images.nyc3.digitaloceanspaces.com/logo-tc.png" />
                                            </div>
                                        </label>
                                    </div>

                                    <small className="privacy-note">
                                        Tus datos personales se utilizarán para procesar tu pedido.
                                    </small>

                                    <button className="buy-btn mt-3" onClick={this.handleSubmit}>{
                                        this.state.paymentMethod === 'TRANSFER' ? 'Comprar con Transferencia' : 'Comprar con Tarjeta de Crédito/Débito'
                                    }</button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

export default withRouter(Checkout);
